import React from 'react';
import { Button } from '../components/UI/Button';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe, Award, Clock, Check, AlertTriangle, MessageSquare } from 'lucide-react';
export const Membership = () => {
  return <div className="pt-20 bg-white" data-id="element-3896" data-mp="38goawk6d4td8">
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3897" data-mp="33fqvuggngffy">
        <div className="absolute inset-0 z-0" data-id="element-3898" data-mp="3hfrwbut05kuw">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3899" data-mp="3hegtbx7dsh4u" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3900" data-mp="3r5uro1nljawe"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3901" data-mp="3m5zzlus34f9r">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3902" data-mp="3m8ui3grjfq0j">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3903" data-mp="4z67coxmi8im">
              LIMITED TIME OFFER
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3904" data-mp="6qfh2a1imq2t">
              The Inner Circle Membership
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3905" data-mp="bpscvkad77hj">
              Join The Networking Salon Inner Circle — practical digital skills,
              a network you can actually reach, and real access to jobs,
              partnerships, funding, and mentorship.
            </p>
            <Button className="text-lg px-8 py-4" data-id="element-3906" data-mp="pnys1j7jairv">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Announcement Section */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3907" data-mp="zfw5kwm0lmtr">
        <div className="container mx-auto px-4" data-id="element-3908" data-mp="13g6iyuc4zfin">
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8 text-center" data-id="element-3909" data-mp="13fn2li24wz6q">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-3910" data-mp="18deuwd6oynbg">
              Special Founder's Offer
            </h2>
            <div className="flex flex-col md:flex-row justify-center gap-8 mb-6" data-id="element-3911" data-mp="39hh9ykxkypud">
              <div data-id="element-3912" data-mp="34inysz5rnaxd">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3913" data-mp="34j61oemxone9">Regular Price:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3914" data-mp="3j7k26iwvnzrn">₦50,000/year</p>
              </div>
              <div className="md:border-l md:border-gray-300 md:pl-8" data-id="element-3915" data-mp="3egtxl7wa00y0">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3916" data-mp="3efiw5eqaz5a2">Founder's Offer:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3917" data-mp="3s6xctewqmudy">₦20,000/year</p>
                <p className="text-gray-600 italic" data-id="element-3918" data-mp="3o7erwj4x2jb4">(until Dec 31 only)</p>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-3919" data-mp="5zz60okxi2z8">
              <p className="text-gray-700" data-id="element-3920" data-mp="11xkzy3xztl4">
                Subscriptions officially begin Jan 1, 2025 — join now and get
                December free.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3921" data-mp="22uvcnqlzgg4h">
        <div className="container mx-auto px-4" data-id="element-3922" data-mp="iazvtzivmr0p">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3923" data-mp="idcnx5icmhrh">
            Membership Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-3924" data-mp="8lgbsqjfgr49">
            {[{
            title: 'Mastermind Sessions',
            description: 'Live idea feedback & strategy polishing',
            icon: <Lightbulb size={24} data-id="element-3925" data-mp="3vp4mkq7f0f0i" />
          }, {
            title: 'Project Handholding',
            description: 'Step-by-step guidance',
            icon: <Users size={24} data-id="element-3926" data-mp="4hs6kei9q7m6" />
          }, {
            title: 'AI Tools Catalogue',
            description: 'Curated tools + playbooks',
            icon: <Bot size={24} data-id="element-3927" data-mp="3qq9wd374bo6d" />
          }, {
            title: 'Virtual Networking Salons',
            description: 'Free & unlimited for members',
            icon: <Video size={24} data-id="element-3928" data-mp="1jyskpfu1nzxa" />
          }, {
            title: 'Discounted Access to Live Events',
            description: 'Special pricing for Inner Circle members',
            icon: <Calendar size={24} data-id="element-3929" data-mp="3l21t0mlz5cy2" />
          }, {
            title: 'Exclusive Resource Hub',
            description: 'Templates & toolkits',
            icon: <FileText size={24} data-id="element-3930" data-mp="3c1n5rhpg9nrx" />
          }, {
            title: 'Mentorship & Expert Access',
            description: 'Group coaching & hot-seat sessions',
            icon: <UserPlus size={24} data-id="element-3931" data-mp="375691z46q138" />
          }, {
            title: 'Visibility & Collaboration Opportunities',
            description: 'Connect with other members',
            icon: <Globe size={24} data-id="element-3932" data-mp="2xbpcwogks9we" />
          }].map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3933" data-mp="2tbf4l55b97ed" data-mpi={index}>
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3934" data-mp="2odn2jiayc4wg">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3935" data-mp="2edw8fhqazrww">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-3936" data-mp="249fw2yc18sxu">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Community Structure */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3937" data-mp="2e8wy95s2sop2">
        <div className="container mx-auto px-4" data-id="element-3938" data-mp="2e6khgvy20kdl">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3939" data-mp="2j8058vrm94zo">
            Event & Community Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3940" data-mp="1llt0nlvbbcnb">
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3941" data-mp="1qjujq6sqnbys">
              <div className="flex items-center mb-4" data-id="element-3942" data-mp="1vhmct454d44k">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3943" data-mp="1vg2ul7zwkj05">
                  <MessageSquare size={24} data-id="element-3944" data-mp="12ti1o33s3yuh" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3945" data-mp="12t8c2gmnbtpb">
                  WhatsApp Groups
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3946" data-mp="zrm020dlto5m">
                <p className="text-gray-600 mb-4" data-id="element-3947" data-mp="zpsny5k82bq8">
                  Reserved exclusively for physical event attendees only.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3948" data-mp="19hygphiasx6h">
                  <li data-id="element-3949" data-mp="14ivmyt7rqddt">Event-specific discussions</li>
                  <li data-id="element-3950" data-mp="14j3z2iw2heny">Limited-time access</li>
                  <li data-id="element-3951" data-mp="gsrikjmra9lr">City-based connections</li>
                </ul>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3952" data-mp="bu6kapr2dzzy">
              <div className="flex items-center mb-4" data-id="element-3953" data-mp="bwav7rndrz9q">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3954" data-mp="qs8q76lkixkd">
                  <Users size={24} data-id="element-3955" data-mp="lqt193g9s6wp" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3956" data-mp="225uj92ujtjb6">
                  Inner Circle Membership
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3957" data-mp="1x6zvrnlmz6kq">
                <p className="text-gray-600 mb-4" data-id="element-3958" data-mp="24pr1hz55horu">
                  Ongoing access to our premium community resources.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3959" data-mp="29nsjegqubi1q">
                  <li data-id="element-3960" data-mp="1vrx40kvngp33">Regular masterminds</li>
                  <li data-id="element-3961" data-mp="1zrfmla000o2r">Virtual salons</li>
                  <li data-id="element-3962" data-mp="1zsh3vw7ly6sx">Exclusive resources</li>
                  <li data-id="element-3963" data-mp="2nh9xvn4o64kw">Ongoing opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lifetime Access */}
      <section className="py-16 border-b border-gray-200" data-id="element-3964" data-mp="2sih6tpijt9t5">
        <div className="container mx-auto px-4" data-id="element-3965" data-mp="2enx12a3hiitj">
          <div className="max-w-3xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3966" data-mp="2en5chj8b1lcr">
            <div className="flex items-center justify-center mb-6" data-id="element-3967" data-mp="2iogtx1h0z09v">
              <Award size={36} className="text-gray-700 mr-3" data-id="element-3968" data-mp="36fckjv9qvpfj" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-3969" data-mp="3b6ma6vvamsrf">
                Lifetime Access Notice
              </h2>
            </div>
            <p className="text-gray-600 text-lg text-center mb-6" data-id="element-3970" data-mp="2mhj8exkxtcx5">
              As a thank-you, everyone who has ever paid for past Networking
              Salon events now has Lifetime Inner Circle Access — which includes
              all membership benefits (masterminds, resources, AI tools, and
              virtual salons).
            </p>
            <div className="flex items-start bg-gray-100 p-4 rounded-lg border border-gray-300" data-id="element-3971" data-mp="35fm2vrw9822c">
              <AlertTriangle size={24} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3972" data-mp="30fg6xziybteg" />
              <p className="text-gray-700" data-id="element-3973" data-mp="2vgmr40g6zqb4">
                <span className="font-bold" data-id="element-3974" data-mp="2vflj64uh3jxm">Clarification:</span> Lifetime
                Access does not include free entry to Live physical events.
                Tickets must still be purchased separately.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3975" data-mp="1f1bs32yujh33">
        <div className="container mx-auto px-4" data-id="element-3976" data-mp="3qqrr4nhf4e5u">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3977" data-mp="3qnx7uza54ze0">
            Choose Your Membership
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3978" data-mp="4j1uz42lul9a">
            {/* Lifetime Inner Circle Access */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3979" data-mp="9aa6q6reqipm">
              <div className="absolute top-0 right-0 bg-gray-800 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3980" data-mp="e9d0gv1xt2ia">
                EXCLUSIVE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3981" data-mp="n99ulc73itkq">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3982" data-mp="nakuh0xf7h6k">
                  <Award size={32} className="text-gray-700" data-id="element-3983" data-mp="s7l23g9x4rzs" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3984" data-mp="2p2qzi83udgbs">
                Lifetime Inner Circle Access
              </h3>
              <p className="text-center text-gray-600 mb-6" data-id="element-3985" data-mp="c129xmebl9mh">
                💎 Exclusive for Past Event Attendees
              </p>
              <div className="border-t border-b border-gray-300 py-4 mb-6" data-id="element-3986" data-mp="h0f0ah4egytt">
                <p className="text-center text-gray-700 font-medium" data-id="element-3987" data-mp="lygothklhqco">
                  One-time gift for loyalty
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3988" data-mp="pxyzzlmm6n2b">
                <li className="flex items-start" data-id="element-3989" data-mp="v06eoiytwh8c">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3990" data-mp="uxkb0uf26lve" />
                  <span className="text-gray-600" data-id="element-3991" data-mp="zwerhppjzycc">
                    All Inner Circle membership benefits
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3992" data-mp="19okk91nmqjsl">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3993" data-mp="19qdo696uypww" />
                  <span className="text-gray-600" data-id="element-3994" data-mp="1drpiut4la1by">Masterminds & resources</span>
                </li>
                <li className="flex items-start" data-id="element-3995" data-mp="1ip9081wl2u84">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3996" data-mp="337a0eqvgbddm" />
                  <span className="text-gray-600" data-id="element-3997" data-mp="2y7f9inboensk">
                    AI tools & virtual salons
                  </span>
                </li>
                <li className="flex items-start text-gray-700 bg-gray-100 p-2 rounded" data-id="element-3998" data-mp="2u6vbzin6xi5w">
                  <AlertTriangle size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3999" data-mp="2p8k257wwb7no" />
                  <span data-id="element-4000" data-mp="3lw7x9wi59pc3">
                    Does NOT include free entry to Live physical events
                  </span>
                </li>
              </ul>
              <div className="bg-gray-200 text-center p-3 rounded-lg mb-6" data-id="element-4001" data-mp="3d4xv5gt24kvs">
                <span className="font-bold text-gray-700" data-id="element-4002" data-mp="3d2uvs660lfee">
                  You're Already In!
                </span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-4003" data-mp="9gmcvi9d6vw0">
                Already a Lifetime Member? Claim Your Access
              </Button>
            </div>
            {/* Founder's Offer */}
            <div className="border-2 border-gray-700 rounded-lg p-8 relative scale-105 shadow-lg" data-id="element-4004" data-mp="nl4oy59t8e7p">
              <div className="absolute -top-4 -right-4 bg-gray-800 text-white px-4 py-2 text-sm font-bold rounded-lg transform rotate-6" data-id="element-4005" data-mp="sl97s1y6xl13">
                BEST VALUE
              </div>
              <div className="flex justify-center mb-6" data-id="element-4006" data-mp="iuoaqiy60oka">
                <div className="w-16 h-16 border-2 border-gray-700 rounded-full flex items-center justify-center" data-id="element-4007" data-mp="it3fer4111ld">
                  <Clock size={32} className="text-gray-700" data-id="element-4008" data-mp="4xht4rp6gvwn" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-4009" data-mp="9rvhwb9c44sc">
                Founder's Offer
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-4010" data-mp="3w0wq0hrqybr3">
                🔥 Available Until Dec 31, 2024
              </p>
              <div className="text-center mb-6" data-id="element-4011" data-mp="1q9sym17ac9wb">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4012" data-mp="1ua3319ffis92">₦20,000</p>
                <p className="text-gray-600" data-id="element-4013" data-mp="1u7z312knide2">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-4014" data-mp="3esx3cgir32nq">
                <li className="flex items-start" data-id="element-4015" data-mp="3aqipybxuov3u">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4016" data-mp="3artu4cv7k4vh" />
                  <span className="text-gray-600" data-id="element-4017" data-mp="3oiys7aixgp3p">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4018" data-mp="3jpdtfg9ifr3g">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4019" data-mp="29nv9jr7ih0u" />
                  <span className="text-gray-600" data-id="element-4020" data-mp="3thtc6fsmsjpe">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4021" data-mp="b9awa4g0xktd">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4022" data-mp="6c2ei4ysfisn" />
                  <span className="text-gray-600" data-id="element-4023" data-mp="2d28kfmyuvp7z">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4024" data-mp="285i36wbbenkz">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4025" data-mp="2aivffu2yljz0" />
                  <span className="text-gray-600" data-id="element-4026" data-mp="2ejnpgpjnnswc">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-4027" data-mp="2jja493f4th79">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4028" data-mp="2jjjwkxnng0g4" />
                  <span className="text-gray-600" data-id="element-4029" data-mp="2ogsagm1rlibk">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6" data-id="element-4030" data-mp="1qw63jan2np1a">
                <span className="font-medium text-gray-700" data-id="element-4031" data-mp="1vu7oy27z00fx">
                  Bonus: Subscription officially starts Jan 1, 2025 (December
                  free!)
                </span>
              </div>
              <Button className="w-full" data-id="element-4032" data-mp="25ktx5bdcxool">Join Now at ₦20,000</Button>
            </div>
            {/* Standard Membership */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-4033" data-mp="181r1td9dli9r">
              <div className="absolute top-0 right-0 bg-gray-600 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-4034" data-mp="1d13q82fwaxeg">
                REGULAR PRICE
              </div>
              <div className="flex justify-center mb-6" data-id="element-4035" data-mp="10ldthh80kodd">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4036" data-mp="vl9ankjmvhjz">
                  <Users size={32} className="text-gray-700" data-id="element-4037" data-mp="qmerghhr7qzc" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-4038" data-mp="ml30o8n58zpk">
                Standard Membership
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-4039" data-mp="ht2wg401jkn6">
                📌 From Jan 1, 2025
              </p>
              <div className="text-center mb-6" data-id="element-4040" data-mp="cv1ddj2m7lbp">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4041" data-mp="7w6u6g0qjur2">₦50,000</p>
                <p className="text-gray-600" data-id="element-4042" data-mp="2wkiib0k2mkd">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-4043" data-mp="2vsjsrbnw8pv">
                <li className="flex items-start" data-id="element-4044" data-mp="3uzuvlp2u26an">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4045" data-mp="3v166s9ylygbs" />
                  <span className="text-gray-600" data-id="element-4046" data-mp="3kdpv6wcpt6t1">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4047" data-mp="3beum9ciadim1">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4048" data-mp="3bg5ov8zzwkbk" />
                  <span className="text-gray-600" data-id="element-4049" data-mp="3gegypjqaiuts">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4050" data-mp="bzg3wxm0pgpw">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4051" data-mp="by65267cc4i7" />
                  <span className="text-gray-600" data-id="element-4052" data-mp="3uce0cujlprfb">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4053" data-mp="34t1mabnhkhv">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4054" data-mp="qvp0tsifrhz5" />
                  <span className="text-gray-600" data-id="element-4055" data-mp="vnoux4btrgnt">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-4056" data-mp="151gw5yl2s3xf">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4057" data-mp="1505srzvjky6u" />
                  <span className="text-gray-600" data-id="element-4058" data-mp="110expjyzfvwi">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6 invisible" data-id="element-4059" data-mp="1etweix0aauiu">
                <span data-id="element-4060" data-mp="19v1x9zhyte0u">Spacer</span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-4061" data-mp="m2mlb0oqfnmj">
                Join for ₦50,000
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gray-50" data-id="element-4062" data-mp="w2lr4ptrozvp">
        <div className="container mx-auto px-4 text-center" data-id="element-4063" data-mp="vzhfj7dz31v0">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-4064" data-mp="r1poefl5jjrv">
            Stop Collecting Contacts. Start Building Connections That Change
            Your Future.
          </h2>
          <Button className="text-lg px-8 py-4" data-id="element-4065" data-mp="22h4jtexpq3kv">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
          <p className="mt-6 text-gray-600" data-id="element-4066" data-mp="qdugzwvvkna">
            Offer ends December 31, 2024. Regular price ₦50,000/year from
            January 1, 2025.
          </p>
        </div>
      </section>
    </div>;
};